import React, { useContext, useEffect } from 'react';

import {
    Paper,
    Avatar,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Typography,
    Tooltip,
    IconButton,
    Link
} from '@material-ui/core';

import { PageContext } from '../PageContext';

import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendarOutlined';
import PeopleIcon from '@material-ui/icons/People';
import CloudIcon from '@material-ui/icons/CloudOutlined';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        overflow: 'hidden'
    },
    author: {
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        marginRight: theme.spacing(1)
    }
}));

export const RoleList = ({
    disabled,
    onViewRole,
    onManageUsers,
    ...props }) => {
    const classes = useStyles();

    const {
        state
    } = useContext(PageContext);

    const {
        roles
    } = state;

    const viewRoleClickHandler = (role) => {
        if (onViewRole) onViewRole(role);
    }

    const manageUsersClickHandler = (role) => {
        if (onManageUsers) onManageUsers(role);
    }

    return (
        <Paper className={classes.root}>
            <Table arial-label="roles list">
                <TableHead>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell align="center">Members</TableCell>
                        <TableCell align="right"></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {roles && roles.map((role, index) =>
                        <TableRow hover key={index}>
                            <TableCell component="th" scope="row">
                                <div className={classes.author}>
                                    <Avatar aria-label="recipe" className={classes.avatar}>
                                        <PermContactCalendarIcon />
                                    </Avatar>
                                    <Link
                                        component="button"
                                        color="textSecondary"
                                        disabled={disabled}
                                        onClick={() => viewRoleClickHandler(role)}>
                                        <Typography>
                                            {role.groupName}
                                        </Typography>
                                    </Link>
                                </div>
                            </TableCell>
                            <TableCell align="center">
                                <Typography>
                                    {role.membersCount}
                                </Typography>
                            </TableCell>
                            <TableCell align="right">
                                <Tooltip title="Manage users">
                                    <span>
                                        <IconButton
                                            disabled={disabled}
                                            onClick={() => manageUsersClickHandler(role)}>
                                            <PeopleIcon />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </Paper>
    );
}